<template lang="pug">
	.element-events(:class="target")
		.header-container(v-if="(target === 'element' && element) || target === 'global' || target === 'screen'")
			.default-header(v-if="target === 'global'")
				.name Global events and behavior
			.default-header(v-else-if="target === 'screen'")
				.name Scene events and behavior
			.default-header(v-else-if="target === 'element'")
				.name Element events and behavior
			.revert-button(v-if="_.size(changedEvents) > 0" v-on:click="revertEvents()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Revert all changes in events'}")
				.fa.fa-rotate-left
		.events-list(v-pseudo-modal-name="'events-list'")
			.event-container(v-for="event in events")
				.event-header
					.event-title {{event.title}}
					.event-controls
						.control.play(@click="callEvent(event)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Process event actions'}")
							i.fa.fa-play-circle
						.control.add-action(@click="openEventActionAddMenu($event, event)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Add event action'}")
							.fa.fa-plus-circle
					.options
						.option.restore(v-if="changedEvents[event.codename]" v-on:click="revertEvent(event)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Revert changes in event'}")
							.fa.fa-rotate-left
						.option.remove(@click="removeEvent(event)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Delete event'}")
							.fa.fa-remove
				.event-actions
					.event-action(v-for="(eventAction, position) in event.actions" :set="eventActionProperties = Metadata.EventActionsByCodename[eventAction.eventActionCodename]")
						.event-action-header
							.item-dot
								.fa.fa-circle
							.event-action-title(@click="editedEventActionKey = `${event.codename}:${position}`")
								.fa(v-if="eventAction.eventActionCodename" :class="eventActionProperties?.icon")
								span(:title="getEventActionMessage(eventAction)") {{getEventActionMessage(eventAction)}}
							//.options
								.option.edit(v-if="eventActionProperties?.options?.editable")
									.fa.fa-pencil
								.option.remove(@click="removeEventAction(event, position, eventActionProperties)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Delete event action'}")
									.fa.fa-remove
						.event-action-settings(v-if="eventAction.eventActionCodename === 'set-element-property-value' && editedEventActionKey === `${event.codename}:${position}`" :set="propertyParams = Metadata.ElementPropertiesByCodename[eventAction.elementPropertyCodename]")
							.control-dropdown-asset-image(v-if="propertyParams?.options?.control === 'EditorPropertyImage'")
								EditorPropertyImage(v-on:change="updateEventAction(event, position, {elementPropertyValue: $event.assetCodename})" :value="eventAction.elementPropertyValue")
							.control-dropdown-localization-text(v-if="propertyParams?.options?.control === 'EditorPropertyText'")
								EditorPropertyText(v-on:change="updateEventAction(event, position, {elementPropertyValue: $event.textCodename})" :value="eventAction.elementPropertyValue")
							.control-number(v-if="propertyParams?.options?.control === 'InputRange'")
								InputRange(v-on:change="updateEventAction(event, position, {elementPropertyValue: $event})" :title="propertyParams.title" :default="propertyParams['default']" :value="eventAction.elementPropertyValue" :options="propertyParams['options']" theme="dark-mini")
							.control-number(v-else-if="propertyParams?.options?.control === 'Select'")
								Select(v-on:change="updateEventAction(event, position, {elementPropertyValue: $event})" :title="propertyParams.title" :default="propertyParams['default']" :value="eventAction.elementPropertyValue" :values="propertyParams['options']['values']" :type="propertyParams.type" theme="dark-mini")
							.control-coords(v-else-if="propertyParams?.options?.control === 'InputCoordsDrag'")
								InputCoordsDrag(v-on:change="updateEventAction(event, position, {elementPropertyValue: $event})" :title="propertyParams.title" :default="propertyParams['default']" :value="eventAction.elementPropertyValue" :type="propertyParams.type" :options="propertyParams.options" theme="dark-mini")
							.control-coords(v-else-if="propertyParams?.options?.control === 'InputNumberDrag'")
								InputNumberDrag(v-on:change="updateEventAction(event, position, {elementPropertyValue: $event})" :title="propertyParams.title" :default="propertyParams['default']" :value="eventAction.elementPropertyValue" :options="propertyParams.options" theme="dark-mini")
							.control-coords(v-else-if="propertyParams?.options?.control === 'InputAngle'")
								InputAngle(v-on:change="updateEventAction(event, position, {elementPropertyValue: $event})" :title="propertyParams.title" :default="propertyParams['default']" :value="eventAction.elementPropertyValue" :type="propertyParams.type" :options="propertyParams.options" theme="dark-mini")
							.control-boolean(v-else-if="propertyParams?.options?.control === 'InputSwitch'")
								InputSwitch(v-on:change="updateEventAction(event, position, {elementPropertyValue: $event})" :title="propertyParams.title" :default="propertyParams['default']" :value="eventAction.elementPropertyValue" :type="propertyParams.type" :options="propertyParams.options" theme="dark-mini")
						.event-action-settings(v-if="eventActionProperties.options.control && editedEventActionKey === `${event.codename}:${position}`")
							.control-input(v-if="eventActionProperties.options.control === 'InputText'")
								InputText(v-on:change="updateEventAction(event, position, {value: $event})" :title="eventActionProperties.options.controlOptions['title']" :default="eventActionProperties.options.controlOptions['default']" :value="eventAction.value" :options="eventActionProperties.options.controlOptions" theme="dark-mini")
						.event-action-properties(v-show="editedEventActionKey === `${event.codename}:${position}`")
							.control-coords
								InputNumberDrag(v-on:change="updateEventAction(event, position, {delay: $event})" :default="0" :value="eventAction.delay" title="Delay" :options="{changes: {min: 0, step: 0.1, accuracy: 1}, controlOptions: {drag: true, icon: 'fa-arrows-v'}, titleWidth: 150}" theme="dark-mini")
						.options(v-show="editedEventActionKey === `${event.codename}:${position}`")
							.option.remove(@click="removeEventAction(event, position, eventActionProperties)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Delete event action'}")
								.fa.fa-remove
		.events-controls
			.dropdown-element-event
				.dropdown-control(@click="openEventAddMenu($event)")
					.value Add event
					.drop-icon.fa.fa-caret-down
</template>

<script>

	import Screen 							from './../../mixins/screen'

	import { Version }						from './../../services/Version'
	import { ScreenService }				from './../../services/Screen'
	import { Elements }						from './../../services/Elements'
	import { Events }						from './../../services/Events'

	import EditorPropertyImage				from './../Editor/Controls/EditorPropertyImage'
	import EditorPropertyText				from './../Editor/Controls/EditorPropertyText'
	import InputRange						from './../Editor/Controls/InputRange'
	import Select							from './../Editor/Controls/Select'
	import InputCoordsDrag					from './../Editor/Controls/InputCoordsDrag'
	import InputNumberDrag					from './../Editor/Controls/InputNumberDrag'
	import InputAngle						from './../Editor/Controls/InputAngle'
	import InputSwitch						from './../Editor/Controls/InputSwitch'
	import InputText						from './../Editor/Controls/InputText'

	export default {
		name: 'EditorElementInfoEvents',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Switched",
				"Selected Screen Switched",
				"Selected Element Switched",
				"Global Event Added",
				"Global Event Changed",
				"Global Event Removed",
				"Screen Event Added",
				"Screen Event Changed",
				"Screen Event Removed",
				"Selected Element Event Added",
				"Selected Element Event Changed",
				"Selected Element Event Removed",
				"Selected Version Events Loaded", // Когда делает реверт всем событиям элемента или сцены или глобальным
				"Aside State Changed"
			],
			events: {
				"Pseudo Modal Process Hide": function(names) {

					if (!_.includes(names, 'events-list') && this.editedEventActionKey) {

						this.editedEventActionKey = null;

					}

				},
				// Событие срабатывающее при добавлении нового действия на событие
				"Event Action Added": function(eventId) {

					if (!this.editedEventActionKey) {

						let event = _.find(this.events, event => event.id === eventId);
						if (event) {

							this.editedEventActionKey = `${event.codename}:${event.actions.length-1}`;

						}

					}

				}
			}
		},
		components: {
			EditorPropertyImage,
			EditorPropertyText,
			InputRange,
			Select,
			InputCoordsDrag,
			InputNumberDrag,
			InputAngle,
			InputSwitch,
			InputText
		},
		props: [],
		data() {

			this.screens = {};

			this.versionScreens = null;
			this.versionElements = null;
			this.versionAnimations = null;

			this.target = null;
			this.element = null;
			this.events = [];

			return {
				showed: true,
				editedEventActionKey: null
			};

		},
		mounted() {

		},
		methods: {
			collectData(...params) {

				this.version = Version.SelectedVersion;
				if (!this.version) return; // После удаления последней версии креатива SelectedVersion нету и здесь ошибка - поэтому return;

				this.versionScreens = ScreenService.getVersionScreens(this.version);
				this.versionElements = Elements.getVersionElementsByScreen(this.version);
				this.versionAnimations = AnimationService.getVersionAnimations(this.version);

				this.screen = ScreenService.SelectedScreen;
				this.element = Elements.SelectedElement;

				if (Elements.SelectedElement?.type === 'global') this.target = 'global';
				else if (Elements.SelectedElement?.type === 'root-container') this.target = 'screen';
				else if (Elements.SelectedElement) this.target = 'element';

				if (this.target === 'global') {
					this.events = Events.getGlobalEvents(this.version?.id);
				} else if (this.target === 'screen') {
					this.events = Events.getScreenEvents(this.version?.id, this.screen?.codename);
				} else if (this.target === 'element') {
					this.events = Events.getEvents(this.version?.id, this.element?.["screen_codename"], this.element?.codename);
				}

				// Вычислим, какие события были изменены относительно шаблона
				this.changedEvents = {};

				let templateId = this.version?.options?.templateId;
				if (templateId) {

					// console.log('changedEvents1');

					let versionEvents = _.keyBy(this.events, 'codename'),
						templateEvents = null;

					if (this.target === 'global') {

						templateEvents = _.keyBy(Events.getTemplateGlobalEvents(templateId), 'codename');

					} else if (this.target === 'screen') {

						templateEvents = _.keyBy(Events.getTemplateScreenEvents(templateId, this.screen?.codename), 'codename');

					} else if (this.target === 'element') {

						templateEvents = _.keyBy(Events.getTemplateEvents(templateId, this.element?.["screen_codename"], this.element?.codename), 'codename');

					}

					// console.log('changedEvents2 templateEvents', templateEvents);

					// Сначала проверим события которые присутствуют в версии креатива
					_.each(versionEvents, event => {

						let eventVersion = _.omit(event, ['id', 'publisher_id', 'creative_id', 'version_id']),
							eventTemplate = _.omit(templateEvents[event.codename], ['id', 'template_id', 'banner_id', 'storyboard_id', 'active']);

						let diff1 = Metadata.difference(eventVersion, eventTemplate),
							diff2 = Metadata.difference(eventTemplate, eventVersion);

						// Нужно смотреть только на diff2 - новые добавленные события не должны помечаться изменёнными - их можно только удалить а не реверт сделать
						if (_.size(diff2) > 0) this.changedEvents[event.codename] = true;
						// Но если всё же есть новое добавленное событие мы должны пометь что вся секция событий была изменена - поэтому добавим любой ключ в этот объект
						if (_.size(diff1) > 0) this.changedEvents['new events added'] = true;

						// console.log('changedEvents3 eventVersion eventTemplate', eventVersion, eventTemplate, _.size(diff1) > 0 || _.size(diff2) > 0);

					});

					// Затем проверим события которые есть в шаблоне но возможно были удалены в версии креатива
					_.each(templateEvents, templateEvent => {

						let eventVersion = _.omit(versionEvents[templateEvent.codename], ['id', 'publisher_id', 'creative_id', 'version_id']),
							eventTemplate = _.omit(templateEvent, ['id', 'template_id', 'banner_id', 'storyboard_id', 'active']);

						let diff1 = Metadata.difference(eventVersion, eventTemplate),
							diff2 = Metadata.difference(eventTemplate, eventVersion);

						if (_.size(diff1) > 0 || _.size(diff2)) this.changedEvents[templateEvent.codename] = true;

					});

				}

			},
			getEventActionMessage(eventAction) {

				if (!this.version) return; // После удаления последней версии креатива SelectedVersion нету и здесь ошибка - поэтому return;

				let eventActionProps = Metadata.EventActionsByCodename[eventAction.eventActionCodename];

				if (eventActionProps?.message) {

					let message = eventActionProps.message;

					if (message.indexOf('$screen.title$') !== -1) {

						let screen = ScreenService.getVersionScreens(this.version)[eventAction.screenCodename];

						if (screen) message = message.replace('$screen.title$', screen.title);

					}

					if (message.indexOf('$animation.title$') !== -1) {

						if (eventAction.animationCodename) {

							let animation = AnimationService.AnimationsByHierarchy[this.version.id]?.[eventAction.screenCodename]?.[eventAction.elementCodename]?.[eventAction.animationCodename];

							if (animation) message = message.replace('$animation.title$', animation.title);

						} else if (eventAction.emitterCodename) {

							let emitter = Emitter.EmittersByHierarchy[this.version.id]?.[eventAction.screenCodename]?.[eventAction.elementCodename]?.[eventAction.emitterCodename];

							if (emitter) message = message.replace('$animation.title$', emitter.title);

						}

					}

					/*if (message.indexOf('$emitter.title$') !== -1) {

						let emitter = Emitter.EmittersByHierarchy[this.version.id]?.[eventAction.screenCodename]?.[eventAction.elementCodename]?.[eventAction.emitterCodename];

						if (emitter) message = message.replace('$emitter.title$', emitter.title);

					}*/

					if (message.indexOf('$element.title$') !== -1) {

						let element = Elements.ElementsByHierarchy[this.version.id]?.[eventAction.screenCodename]?.[eventAction.elementCodename];

						if (element) message = message.replace('$element.title$', element.codename);

					}

					if (message.indexOf('$property.title$') !== -1) {

						let propertyProperties = Metadata.ElementPropertiesByCodename[eventAction.elementPropertyCodename];

						if (propertyProperties) message = message.replace('$property.title$', propertyProperties.title);

					}

					if (message.indexOf('$property.title.lower$') !== -1) {

						let propertyProperties = Metadata.ElementPropertiesByCodename[eventAction.elementPropertyCodename];

						if (propertyProperties) message = message.replace('$property.title.lower$', propertyProperties.title.toLowerCase());

					}

					if (message.indexOf('$property.value$') !== -1) {

						let toFixed = 2,
							elementPropertyProperties = Metadata.ElementPropertiesByCodename[eventAction.elementPropertyCodename],
							value = ("elementPropertyValue" in eventAction) ? eventAction.elementPropertyValue : elementPropertyProperties.default;

						if (value && value.toFixed) {

							if ("accuracy" in (elementPropertyProperties?.options?.changes || {})) toFixed = elementPropertyProperties.options.changes.accuracy;

							value = value.toFixed(toFixed);

						}

						message = message.replace('$property.value$', value);

					}

					if (message.indexOf('$event.title$') !== -1) {

						let event = Events.EventsByHierarchy[this.version.id]?.[eventAction.screenCodename]?.[eventAction.elementCodename]?.[eventAction.eventCodename];

						if (event) message = message.replace('$event.title$', event.title);

					}

					if (message.indexOf('$value$') !== -1) {

						let value = eventAction.value;
						if (value === undefined || value === null) value = '';

						message = message.replace('$value$', value);

					}

					return message;

				}

				return eventActionProps?.title || eventAction.eventActionCodename;

			},
			updateEventAction(event, position, data) {

				console.log('updateEventAction', data);

				//event.actions[position].elementPropertyValue = data.elementPropertyValue;

				Server.sendToServer({
					UpdateEventAction: {
						eventId: event.id,
						eventActionPosition: position,
						data
					}
				});

			},
			removeEvent(event) {

				if (this.target === 'global') {

					Broadcast.call('Show Confirm', [{
						caption: 'Delete global event',
						message: `Are you sure you want to delete global event "${event.title}"?`,
						confirmButtonText: '&nbsp;&nbsp;Delete event',
						confirmButtonIcon: 'fa-remove',
						confirmCallback: () => {

							Server.sendToSocket({
								RemoveEvent: {
									eventId: event.id
								}
							});

						}
					}]);

				} else if (this.target === 'screen') {

					Broadcast.call('Show Confirm', [{
						caption: 'Delete scene event',
						message: `Are you sure you want to delete scene event "${event.title}"?`,
						confirmButtonText: '&nbsp;&nbsp;Delete event',
						confirmButtonIcon: 'fa-remove',
						confirmCallback: () => {

							Server.sendToSocket({
								RemoveEvent: {
									eventId: event.id
								}
							});

						}
					}]);

				} else if (this.target === 'element') {

					Broadcast.call('Show Confirm', [{
						caption: 'Delete element event',
						message: `Are you sure you want to delete element event "${event.title}"?`,
						confirmButtonText: '&nbsp;&nbsp;Delete event',
						confirmButtonIcon: 'fa-remove',
						confirmCallback: () => {

							Server.sendToSocket({
								RemoveEvent: {
									eventId: event.id
								}
							});

						}
					}]);

				}

			},
			removeEventAction(event, position, eventActionProps) {

				Broadcast.call('Show Confirm', [{
					caption: 'Delete event action',
					message: `Are you sure you want to delete event action "${eventActionProps?.title}"?`,
					confirmButtonText: '&nbsp;&nbsp;Delete action',
					confirmButtonIcon: 'fa-remove',
					confirmCallback: () => {

						Server.sendToSocket({
							RemoveEventAction: {
								eventId: event.id,
								eventActionPosition: position
							}
						});

					}
				}]);

			},
			callEvent(event) {

				Broadcast.call("Send To iFrame", [{
					CallEvent: {
						eventId: event.id
					}
				}]);

			},
			openEventAddMenu(e) {

				Broadcast.call("Show EditorElementInfoEventsAdd", [e.target.closest('.dropdown-control'), this.element]);

			},
			openEventActionAddMenu(e, event) {

				Broadcast.call("Show EditorElementInfoEventsAddAction", [e.target.closest('.add-action'), this.element, event]);

			},
			revertEvents() {

				let data = {};

				if (this.target === 'global') {

					data = {screenCodename: '', elementCodename: ''};

				} else if (this.target === 'screen') {

					data = {screenCodename: this.screen?.codename, elementCodename: ''};

				} else if (this.target === 'element') {

					data = {screenCodename: this.screen?.codename, elementCodename: this.element?.codename};

				}

				Broadcast.call('Show Confirm', [{
					caption: 'Revert all events changes',
					message: `Are you sure you want to revert all events changes to the template state?`,
					confirmButtonText: '&nbsp;&nbsp;Revert all events',
					confirmButtonIcon: 'fa-rotate-left',
					confirmCallback: () => {

						Server.sendToSocket({
							RevertEvents: {
								versionId: this.version.id,
								...data
							}
						});

					}
				}]);

			},
			revertEvent(event) {

				Broadcast.call('Show Confirm', [{
					caption: 'Revert event changes',
					message: `Are you sure you want to revert event changes to the template state?`,
					confirmButtonText: '&nbsp;&nbsp;Revert event',
					confirmButtonIcon: 'fa-rotate-left',
					confirmCallback: () => {

						Server.sendToSocket({
							RevertEvent: {
								eventId: event.id
							}
						});

					}
				}]);

			}
		}

	}
</script>

<style lang="sass">

	.element-events
		background-color: #343b41
		color: #f3f4f5

		.header-container
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			align-items: center
			height: 46px
			padding: 5px
			border-bottom: 1px solid #23282c
			cursor: default
			position: relative

			.default-header
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				align-items: center
				justify-content: center
				width: 100%

				.name
					color: #73818f
					display: flex
					padding: 5px

			.revert-button
				right: 12px
				top: 12px
				border: none
				background: transparent
				font-size: 13px
				position: absolute
				cursor: pointer

				.fa
					color: rgba(255, 255, 255, 0.05)

				&:hover

					.fa
						color: #20a8d8

		.events-list

			.event-container
				display: flex
				flex-direction: column
				flex-wrap: nowrap
				border-bottom: 1px solid #2e3235
				padding-left: 0.5rem
				padding-right: 0.5rem
				min-height: 32px
				justify-content: center

				.event-header
					display: flex
					flex-direction: row
					flex-wrap: nowrap
					width: 100%
					align-items: center

					.event-title
						display: flex
						align-items: center
						justify-content: left
						width: 100px
						color: var(--orange)
						font-size: 14px
						cursor: default
						user-select: none
						white-space: nowrap

					.event-controls
						display: flex
						flex-direction: row

						transition: 0.2s
						padding: 2px 0
						font-size: 18px
						color: #fff
						margin-left: auto

						.control
							color: rgba(255, 255, 255, 0.25)
							margin-right: 4px
							cursor: pointer
							padding: 0 4px

						.control:hover

							.fa
								color: #20a8d8

						.control:active

							.fa
								color: var(--green)

					.options
						display: flex
						flex-direction: row
						flex-wrap: nowrap
						align-items: center
						justify-content: right
						width: 35px

						.option
							width: 15px
							height: 15px
							border: 1px solid rgba(255, 255, 255, 0.09)
							background-color: rgba(255, 255, 255, 0.05)
							border-radius: 0.1rem
							cursor: pointer
							margin-right: 2px

							&.remove, &.restore
								border: none
								background: transparent
								font-size: 11px
								margin-left: 5px

								.fa
									color: rgba(255, 255, 255, 0.15)

								&:hover

									.fa
										color: #20a8d8

							&.remove
								font-size: 14px
								display: flex
								align-items: center
								margin-top: 1px

							&:last-child
								margin-right: 0

				.event-actions
					display: flex
					flex-direction: column
					flex-wrap: nowrap
					padding-left: 1rem
					justify-content: center

					.event-action
						display: flex
						flex-direction: column
						flex-wrap: nowrap
						width: 100%
						align-items: center
						border-bottom: 1px solid #2e3235
						justify-content: left
						padding: 2px 0
						position: relative

						.event-action-header
							display: flex
							flex-direction: row
							flex-wrap: nowrap
							width: 100%
							justify-content: left
							align-items: center

							.item-dot
								font-size: 4px
								color: #73818f

							.event-action-title
								display: flex
								align-items: center
								justify-content: left
								font-size: 14px
								user-select: none
								white-space: nowrap
								overflow: hidden
								text-overflow: ellipsis
								padding: 0 10px
								color: var(--green)
								cursor: pointer

								.fa
									margin-right: 10px
									margin-top: 2px

								span
									overflow: hidden
									text-overflow: ellipsis

								&:hover
									color: var(--secondary)

						.event-action-settings
							display: flex
							flex-direction: row
							align-items: center
							width: 100%

							&> div
								margin-left: 40px

						.event-action-properties
							display: flex
							flex-direction: row
							align-items: center
							width: 100%

							&> div
								margin-left: 40px

						.options
							display: flex
							flex-direction: row
							flex-wrap: nowrap
							align-items: center
							justify-content: right
							width: 35px
							position: absolute
							right: 0
							top: 5px

							.option
								width: 15px
								height: 15px
								cursor: pointer
								margin-right: 1px
								font-size: 11px
								position: relative
								margin-left: auto

								.fa
									position: absolute
									left: 2px
									top: 2px
									color: rgba(255, 255, 255, 0.15)

								&:hover

									.fa
										color: #20a8d8

								&.edit
									margin-right: 2px

								&.remove
									font-size: 13px
									margin-top: -1px

					.event-action:last-child
						border-bottom: none

		.events-controls
			display: flex
			flex-direction: row
			justify-content: left
			padding-top: 10px
			border-top: 1px solid #2e3235

			.dropdown-element-event
				margin-left: 5px

				.dropdown-control
					border: 1px solid rgba(255, 255, 255, 0.1)
					border-radius: 0.25rem
					background: rgba(255, 255, 255, 0.05) no-repeat
					background-position-x: right 0.75rem
					background-position-y: calc(50% - 1px)
					background-size: 8px 10px
					padding-top: 0.25rem
					padding-bottom: 0.25rem
					padding-right: 2rem
					padding-left: 0.5rem
					color: rgba(255, 255, 255, 0.5)
					cursor: pointer
					font-size: 0.765625rem
					position: relative
					user-select: none

					&:hover
						border: 1px solid rgba(255, 255, 255, 0.3)
						background: rgba(255, 255, 255, 0.1) no-repeat

					.value
						max-width: 125px
						overflow: hidden
						text-overflow: ellipsis
						white-space: nowrap

					.drop-icon
						position: absolute
						right: 13px
						top: 8px
						color: rgba(255, 255, 255, 0.50)

				.dropdown-control:hover, .dropdown-control.active
					border: 1px solid #20a8d8
					background: rgba(255, 255, 255, 0.1) no-repeat

					.value, .drop-icon
						color: #20a8d8

	//.element-events.global
		margin: 0 -1rem
		margin-top: 15px
		border-top: 1px solid #23282c
		background: none

		.header-container
			position: absolute
			top: 0
			right: 0
			border-bottom: 0
		//display: none

		.events-controls
			padding-left: 10px

</style>
